import { render, staticRenderFns } from "./ChatbotSidebar.vue?vue&type=template&id=806c366c&"
import script from "./ChatbotSidebar.vue?vue&type=script&lang=js&"
export * from "./ChatbotSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports